<template>
  <sfs-base-list-filter
    title="Filter Versions"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="displayedColumns"
    :available-columns="availableColumns"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
  >
    <template #quick-filters>
      <b-form-group
        label="Search fields for Data"
        label-for="quick-filter-model"
        label-sr-only
      >
        <b-input-group>
          <user-select
            id="quick-filter-user_id"
            placeholder="Filter by User"
            :value="user"
            @input="onUserChange"
          />
          <template #append>
            <b-button
              id="quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>

    <template #advanced-filters>
      <b-row>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Record Type"
            label-for="advanced-filter-model"
            label-sr-only
          >
            <v-select
              id="advanced-filter-model"
              v-model="filters.model"
              :options="modelOptions"
              placeholder="Filter by Record Type"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Model ID"
            label-for="advanced-filter-model_id"
            label-sr-only
          >
            <b-form-input
              id="advanced-filter-model_id"
              v-model="filters.model_id"
              type="text"
              placeholder="Record ID"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Type of Event"
            label-for="advanced-filter-event"
            label-sr-only
          >
            <v-select
              id="advanced-filter-event"
              v-model="filters.event"
              :options="eventOptions"
              placeholder="Filter by Type of Event"
              :reduce="(event) => event.value"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Start Date"
            label-for="advanced-filter-start_date"
            label-sr-only
            content-cols-lg="12"
          >
            <sfs-date-picker
              id="advanced-filter-start_date"
              v-model="filters.start_date"
              placeholder="Start Date"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="End Date"
            label-for="advanced-filter-end_date"
            label-sr-only
            content-cols-lg="12"
          >
            <sfs-date-picker
              id="advanced-filter-end_date"
              v-model="filters.end_date"
              placeholder="End Date"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </sfs-base-list-filter>
</template>
<script>
import {
  VERSION_TABLE_COLUMN_OPTIONS,
  VERSION_TABLE_DEFAULT_COLUMNS,
  VERSION_MODEL_OPTIONS,
  VERSION_EVENT_OPTIONS,
  VERSION_TABLE_NAME,
} from '@/constants/versions';
import UserSelect from '@/components/admin/users/Select.vue';
import listFilterMixin from '@/mixins/listFilterMixin';

export default {
  name: 'VersionsListFilter',
  mixins: [listFilterMixin],
  components: {
    UserSelect,
  },
  data() {
    return {
      availableColumns: VERSION_TABLE_COLUMN_OPTIONS,
      tableName: VERSION_TABLE_NAME,
      modelOptions: VERSION_MODEL_OPTIONS,
      eventOptions: VERSION_EVENT_OPTIONS,
    };
  },
  mounted() {
    this.loadInitialFilters();
  },
  methods: {
    onUserChange(user) {
      this.filters.user_id = user ? user.id.toString() : '';
      this.user = user;
    },
    onDefaultPresetApplied() {
      this.filters = {};
      this.displayedColumns = VERSION_TABLE_DEFAULT_COLUMNS;
      this.applyFilters();
    },
    loadInitialFilters() {
      const loadUser = new Promise((resolve) => {
        if (this.initialFilters.user_id) {
          this.$usersAPI.get(this.initialFilters.user_id).then((user) => {
            resolve(user);
          });
        } else {
          resolve(null);
        }
      });

      Promise.all([loadUser]).then((values) => {
        this.user = values[0];
        this.applyFilters();
      });
    },
  },
};
</script>
